import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nConfig } from "./config";
import pt from "./locales/pt.json";
import en from "./locales/en.json";

const fallback = { pt, en };

const mergeLocalFallback = (lng) => {
  const lang = (lng || "").split("-")[0];
  if (fallback[lang]) {
    i18n.addResourceBundle(lang, "translation", fallback[lang], true, true);
  }
};

i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next).init(i18nConfig);

i18n.on("failedLoading", (lng) => {
  mergeLocalFallback(lng);
});

i18n.on("loaded", () => {
  mergeLocalFallback(i18n.language);
});

i18n.on("languageChanged", (lng) => {
  mergeLocalFallback(lng);
});

export default i18n;
